import { EntityId } from '@reduxjs/toolkit';
import { Update } from '@reduxjs/toolkit';
import httpAdapter, { _apiUrlFactory } from '../../../_config/api-provider';

const httpService = httpAdapter();

const prefix = 'accounting/serveur-type';
const apiserveurTypeUrl = _apiUrlFactory(prefix);

export const all = async () => {
	return  httpService.get(`${apiserveurTypeUrl('')}`);
};

export const add = async (mode: any): Promise<Partial<any>> => {
	return  httpService.post(apiserveurTypeUrl(''), mode);
};

export const update = async (mode: Update<any>): Promise<any> => {
	const { id, ...otherProps } = mode;
	return  httpService.put(apiserveurTypeUrl(`${id}`), otherProps);
};

export const _delete = async (id: EntityId) => {
	return  httpService.delete(apiserveurTypeUrl(`${id}`));
  }